module.exports = __webpack_public_path__ + "static/media/duo.317a4b4e.jpg";